// apps/mtd-itsa-web/src/providers/auth-provider.tsx
import { createContext, useContext, useEffect, type ReactNode } from 'react';
import { useSupabaseAuth } from '@kordbooks/shared-auth';
import type { AuthContextType } from '@kordbooks/shared-auth';
import * as Sentry from '@sentry/react';

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
    const auth = useSupabaseAuth();

    // Set user context in Sentry whenever auth state changes
    useEffect(() => {
        if (auth.user?.id) {
            // Set user information for Sentry error tracking
            Sentry.setUser({
                id: auth.user.id,
                email: auth.user.email,
                // Add any other user fields you want to track
                // username: auth.user.username,
                // name: auth.user.name,
            });
        } else {
            // Clear user context when logged out
            Sentry.setUser(null);
        }
    }, [auth.user?.id, auth.user?.email]);

    return (
        <AuthContext.Provider value={auth}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}
